import { useAbonnement } from "../contexts/AbonnementContext";
import { use, useCallback } from "react";

export const useHasAccess = () => {
  const { showAbonnementModal, hideAbonnementModal } = useAbonnement();

  const hasAccess = useCallback((user, feature) => {
    if (!user) {
      console.log("⛔️ user is undefined");
      return false;
    }

    if (user.role === 1) {
      hideAbonnementModal();
      return true;
    }

    if (user?.entreprise?.active === 0) {
      localStorage.clear();
      window.location.href = "/login";
      return false;
    }

    if (!user?.entreprise?.offre) {
      showAbonnementModal();
      return false;
    }

    const now = new Date();
    const expiration = new Date(user.entreprise.dateExpiration);
    if (expiration < now) {
      showAbonnementModal();
      return false;
    }

    const accessList = user.entreprise?.offre?.access || [];
    const hasPermission = accessList.some(
      (item) => {
        if(feature == "admin_alert") {
          return true;
        }else {
          return item.toLowerCase().trim() === feature.toLowerCase().trim();
        }
      }
    );

    if (hasPermission) {
      hideAbonnementModal();
    } else {
      showAbonnementModal();
    }

    return hasPermission;
  }, [showAbonnementModal, hideAbonnementModal]);

  return hasAccess;
};
